import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {ACCOUNT_TABS} from 'src/constants';

import {LICENSE_AND_FEATURES_SUB_TABS} from '../constants';

import {REPORTS_SUB_TABS} from './constants';
import {AssociatedBrowsersReport} from './reports/associeated-browsers';
import {ExcelPluginUsageReportV2} from './reports/excel-plugin-usage-report';
import {PasswordSharingReport} from './reports/password-sharing';
import {UsageReportV2} from './reports/usage-report';
import {UserListReport} from './reports/user-list-report';


type Props = {
    accountId: number,
    licenseId: number,
};

export const ReportTab = ({accountId, licenseId}: Props) => {

    return (
        <Routes>
            <Route
                path={`/${REPORTS_SUB_TABS.USAGE_REPORT.name}`}
                element={<UsageReportV2/>}
            />
            <Route
                path={`/${REPORTS_SUB_TABS.EXCEL_PLUGIN_USAGE_REPORT.name}`}
                element={<ExcelPluginUsageReportV2/>}
            />
            <Route path={`/${REPORTS_SUB_TABS.ASSOCIATED_BROWSERS.name}`} element={<AssociatedBrowsersReport/>}/>
            <Route path={`/${REPORTS_SUB_TABS.USER_LIST.name}`} element={<UserListReport/>}/>
            <Route path={`/${REPORTS_SUB_TABS.PASSWORD_SHARING.name}`} element={<PasswordSharingReport/>}/>

            <Route
                path="*"
                element={(
                    <Navigate

                        to={`/profile/account/${accountId}/${ACCOUNT_TABS.LICENSE.name}/${licenseId}/${LICENSE_AND_FEATURES_SUB_TABS.REPORTS.name}/${REPORTS_SUB_TABS.USAGE_REPORT.name}`}
                    />
                )}
            />
        </Routes>
    );
};
